import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VesselTable from './vesselTable';
import CertificationModal from '../../components/Modals/CertificationModal';

const VesselPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  const handleNewRecordClick = () => {
    navigate('/create-vessel');
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div style={{ marginTop: "6px" }} className="vessel-page">
      <div className="header">
        <h3>Vessel Record</h3>
      </div>
      <hr className='hr'></hr>
      <div className='vessel-table'>
        <VesselTable />
      </div>

      <CertificationModal
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
      />
    </div>
  );
}

export default VesselPage;
